import React from 'react';
import { useSportLobbyCategoriesLinks } from '../../../hooks/main-navigation-v2';
import { getRoute, isActiveRoute } from '../../../services/router';
import { stores } from '../../../stores';
import { useStore } from '../../../hooks/useStore';
import SportNavLinkV2 from '../nav-link-v-2/SportNavLinkV2';

export default function SportLobbyCategoriesV2() {
    const [liveMatchesCount] = useStore(stores.sports.liveMatchesCount);
    const links = useSportLobbyCategoriesLinks();

    return (
        <div>
            {links.map(({ route, icon, label }) => {
                const isLiveCard = route.includes(`${getRoute('sport.live')}`);

                return (
                    <SportNavLinkV2
                        key={route}
                        to={route}
                        icon={icon}
                        label={label}
                        isActive={isActiveRoute(route, false)}
                        {...(isLiveCard && { badge: liveMatchesCount })}
                    />
                );
            })}
        </div>
    );
}
